var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 87,
    viewBox: "0 0 221 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.96533,
    y: 15.655,
    width: 209.881,
    height: 61.8945,
    rx: 10.5,
    fill: "#333333",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.28 26.7414C25.8944 27.1463 25.6631 27.7825 25.6631 28.5923V57.7629C25.6631 58.5727 25.8944 59.2089 26.28 59.6138L26.3764 59.7102L42.7259 43.3608V42.9752L26.3764 26.6257L26.28 26.7414Z",
    fill: "url(#paint0_linear_546_571)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1625 48.8169L42.7256 43.3606V42.975L48.1818 37.5188L48.2975 37.5959L54.7563 41.2591C56.6072 42.3002 56.6072 44.0162 54.7563 45.0766L48.2975 48.7398L48.1625 48.8169Z",
    fill: "url(#paint1_linear_546_571)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.298 48.7398L42.7261 43.1678L26.2803 59.6137C26.878 60.2499 27.8998 60.3463 29.018 59.6908L48.298 48.7398Z",
    fill: "url(#paint2_linear_546_571)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.298 37.6153L29.018 26.6642C27.8805 26.028 26.878 26.1051 26.2803 26.7414L42.7261 43.1872L48.298 37.6153Z",
    fill: "url(#paint3_linear_546_571)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.1631 48.6241L29.018 59.4981C27.9384 60.115 26.9936 60.0765 26.3767 59.5173L26.2803 59.6137L26.3767 59.7101C26.9936 60.2693 27.9576 60.3078 29.018 59.6909L48.298 48.7398L48.1631 48.6241Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M26.28 59.4209C25.8944 59.016 25.6631 58.3798 25.6631 57.57V57.7628C25.6631 58.5726 25.8944 59.2088 26.28 59.6137L26.3764 59.5173L26.28 59.4209ZM54.7373 44.8838L48.1628 48.6241L48.2785 48.7398L54.7373 45.0766C55.6628 44.556 56.1255 43.8619 56.1255 43.1678C56.0484 43.8041 55.5856 44.4018 54.7373 44.8838Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M29.0178 26.8376L54.7373 41.4518C55.5664 41.9338 56.0484 42.5315 56.1255 43.1678C56.1255 42.4737 55.6628 41.7796 54.7373 41.259L29.0178 26.6448C27.1669 25.6037 25.6631 26.4713 25.6631 28.5728V28.7656C25.6631 26.6641 27.1669 25.7965 29.0178 26.8376Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.369 41.6039C104.764 41.6039 101.833 44.3417 101.833 48.1205C101.833 51.8801 104.764 54.6372 108.369 54.6372C111.974 54.6372 114.905 51.8801 114.905 48.1205C114.905 44.3609 111.974 41.6039 108.369 41.6039ZM108.369 52.0729C106.402 52.0729 104.686 50.4341 104.686 48.1205C104.686 45.7684 106.383 44.1681 108.369 44.1681C110.355 44.1681 112.051 45.7684 112.051 48.1205C112.032 50.4341 110.336 52.0729 108.369 52.0729ZM125.875 43.0692H125.779C125.143 42.298 123.909 41.6039 122.347 41.6039C119.089 41.6039 116.1 44.4766 116.1 48.1398C116.1 51.7837 119.089 54.6372 122.347 54.6372C123.909 54.6372 125.143 53.9431 125.779 53.1526H125.875V54.0973C125.875 56.5845 124.545 57.9148 122.405 57.9148C120.65 57.9148 119.571 56.6616 119.127 55.6012L116.64 56.6423C117.353 58.3775 119.262 60.4983 122.424 60.4983C125.779 60.4983 128.613 58.5317 128.613 53.7117V42.0088H125.894L125.875 43.0692ZM122.598 52.0729C120.631 52.0729 118.973 50.4149 118.973 48.1398C118.973 45.8455 120.631 44.1681 122.598 44.1681C124.545 44.1681 126.068 45.8455 126.068 48.1398C126.068 50.4341 124.545 52.0729 122.598 52.0729ZM94.1018 41.6039C90.4964 41.6039 87.5658 44.3417 87.5658 48.1205C87.5658 51.8801 90.4964 54.6372 94.1018 54.6372C97.7071 54.6372 100.638 51.8801 100.638 48.1205C100.638 44.3609 97.7071 41.6039 94.1018 41.6039V41.6039ZM94.1018 52.0729C92.1352 52.0729 90.4193 50.4341 90.4193 48.1205C90.4193 45.7684 92.1159 44.1681 94.1018 44.1681C96.0683 44.1681 97.7842 45.7684 97.7842 48.1205C97.765 50.4341 96.0683 52.0729 94.1018 52.0729ZM77.1161 43.5897V46.3468H83.7291C83.5363 47.9085 83.0158 49.046 82.2253 49.8365C81.2613 50.8005 79.7574 51.8609 77.1161 51.8609C73.048 51.8609 69.8668 48.5833 69.8668 44.5152C69.8668 40.4471 73.048 37.1695 77.1161 37.1695C79.314 37.1695 80.9142 38.0371 82.1096 39.1361L84.0569 37.1888C82.3988 35.6078 80.2009 34.3932 77.1161 34.3932C71.5442 34.3932 66.8398 38.9433 66.8398 44.5152C66.8398 50.0871 71.5249 54.6372 77.1161 54.6372C80.1238 54.6372 82.3988 53.6539 84.1726 51.803C86.0042 49.9714 86.5633 47.4072 86.5633 45.3442C86.5633 44.708 86.5054 44.1103 86.409 43.609L77.1161 43.5897ZM146.524 45.7684C145.984 44.3031 144.326 41.6232 140.952 41.6232C137.597 41.6232 134.802 44.2645 134.802 48.1398C134.802 51.7837 137.559 54.6565 141.261 54.6565C144.249 54.6565 145.984 52.8249 146.698 51.7645L144.48 50.2799C143.748 51.3596 142.726 52.0729 141.28 52.0729C139.834 52.0729 138.793 51.3981 138.118 50.1064L146.833 46.501L146.524 45.7684ZM137.655 47.9277C137.578 45.4021 139.603 44.1296 141.068 44.1296C142.205 44.1296 143.169 44.6887 143.478 45.5177L137.655 47.9277ZM130.56 54.2516H133.414V35.1066H130.56V54.2516ZM159.943 35.1066H153.099V54.2516H155.952V47.0023H159.943C163.105 47.0023 166.228 44.708 166.228 41.0448C166.228 37.4009 163.105 35.1066 159.943 35.1066ZM160.02 44.3031H155.952V37.7479H160.02C162.16 37.7479 163.375 39.5217 163.375 41.0255C163.375 42.5294 162.16 44.3031 160.02 44.3031ZM167.809 54.2516H170.663V35.1066H167.809V54.2516ZM177.681 41.5653C175.618 41.5653 173.458 42.4715 172.571 44.4959L175.116 45.5563C175.656 44.4959 176.659 44.1489 177.719 44.1489C179.204 44.1489 180.707 45.0358 180.727 46.6167V46.8095C180.206 46.5203 179.107 46.0769 177.738 46.0769C175.001 46.0769 172.224 47.5807 172.224 50.3956C172.224 52.9598 174.461 54.5986 176.986 54.5986C178.914 54.5986 179.975 53.731 180.63 52.7285H180.727V54.213H183.484V46.8673C183.503 43.4741 180.958 41.5653 177.681 41.5653V41.5653ZM177.333 52.0729C176.389 52.0729 175.097 51.6102 175.097 50.4534C175.097 48.9689 176.717 48.4097 178.124 48.4097C179.377 48.4097 179.975 48.6797 180.727 49.046C180.515 50.8197 178.992 52.0729 177.333 52.0729ZM193.548 41.9895L190.27 50.2992H190.174L186.781 41.9895H183.696L188.786 53.5961L185.875 60.0741H188.863L196.729 42.0088H193.548V41.9895Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_546_571",
    x1: 41.2598,
    y1: 28.2749,
    x2: 19.1193,
    y2: 50.4155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_546_571",
    x1: 57.1428,
    y1: 43.1775,
    x2: 25.2207,
    y2: 43.1775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_546_571",
    x1: 45.2651,
    y1: 46.2104,
    x2: 15.2409,
    y2: 76.2346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_546_571",
    x1: 22.1389,
    y1: 17.0185,
    x2: 35.546,
    y2: 30.4256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.650a771789a142bb157bd13bbaa90620.svg";
export { ForwardRef as ReactComponent };